module.exports = __webpack_public_path__ + "static/media/skills.ab99fb76.svg";